import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useBroadcastGroupsApi = () => {
  const addToast = useToastContext()
  const [broadcastGroupsState, setBroadcastGroupsState] = useState({
    broadcastGroups: {},
    isLoading: false,
    error: null,
  })

  async function getBroadcastGroups() {
    try {
      setBroadcastGroupsState((currentBroadcastGroupsState) => ({
        ...currentBroadcastGroupsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/broadcastGroups', {
        includeToken: true,
      })
      setBroadcastGroupsState({
        broadcastGroups: {
          data: response.data.data,
          count: response.data.count,
        },
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setBroadcastGroupsState({
        broadcastGroups: null,
        isLoading: false,
        error,
      })
    }
  }

  async function createBroadcastGroup(broadcastGroup) {
    try {
      await api.post('/broadcastGroups', broadcastGroup)
      addToast(notificationTypes.success, 'Grupo de difusión creado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al crear el grupo de difusión: ${error.response.data.message}`
      )
    }
  }

  async function updateBroadcastGroup(id, broadcastGroup) {
    try {
      await api.put(`/broadcastGroups/${id}`, broadcastGroup)
      addToast(
        notificationTypes.success,
        'Grupo de difusión actualizado con exito!'
      )
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al actualizar el grupo de difusión: ${error.response.data.message}`
      )
    }
  }

  const state = {
    broadcastGroupsState,
  }

  const methods = {
    getBroadcastGroups,
    createBroadcastGroup,
    updateBroadcastGroup,
  }

  return [state, methods]
}

export default useBroadcastGroupsApi
